'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var ReservationSystemService = function ReservationSystemService(Restangular, $log, userActionService) {
  var flightSend = Restangular.service('domain/flights/send?priority=1000&manuallyTriggered=true');
  var serviceSend = Restangular.service('domain/services/send?priority=1000&manuallyTriggered=true');
  function successHandler(res) {
    toastr.success('Send Request Submitted');
    return res;
  }
  function errorHandler() {
    $log.error('ReservationSystemService: send - Send Request Failed');
    toastr.error('Send Request Failed');
  }
  function prepareSendFlightsRequestParams(rows) {
    var requestParams = {
      sendAuthRequests: []
    };
    rows.forEach(function (row) {
      var incomingSendAuthRequest = {
        carrier: row.carrier,
        number: row.flightNumber,
        opsSuffix: row.opsSuffix,
        scenarioName: 'PUBLISHED',
        numberDepartureDate: row.flightDepartureDateMoment.toISOString()
      };
      if (!_.find(requestParams.sendAuthRequests, incomingSendAuthRequest)) {
        requestParams.sendAuthRequests.push(incomingSendAuthRequest);
      }
    });
    return requestParams;
  }
  function prepareSendServicesRequestParams(rows) {
    var requestParams = {
      sendServiceAuthRequests: []
    };
    rows.forEach(function (row) {
      var incomingSendAuthRequest = {
        carrier: row.carrier,
        serviceId: row.serviceId,
        scenarioName: 'PUBLISHED'
      };
      if (!_.find(requestParams.sendServiceAuthRequests, incomingSendAuthRequest)) {
        requestParams.sendServiceAuthRequests.push(incomingSendAuthRequest);
      }
    });
    return requestParams;
  }
  function send(rows) {
    var requestParams = prepareSendFlightsRequestParams(rows);
    userActionService.saveUserAction('FLIGHT', _.map(rows, 'flightId'), 'SEND');
    return flightSend.post(requestParams).then(successHandler, errorHandler);
  }
  function sendServices(rows) {
    var requestParams = prepareSendServicesRequestParams(rows);
    return serviceSend.post(requestParams).then(successHandler, errorHandler);
  }
  return {
    send: send,
    sendServices: sendServices
  };
};
ReservationSystemService.$inject = ['Restangular', '$log', 'UserActionService'];
module.exports = ReservationSystemService;